/**
 * Mapeamento de permissões de acesso às rotas do sistema
 * Define quais cargos têm acesso a quais rotas
 */
export const ROUTES_PERMISSIONS = {
  // Rotas acessíveis por todos os usuários autenticados
  '/home': ['Admin', 'admin', 'Atendente', 'atendente', 'Recepção', 'Recepcao', 'recepção', 'recepcao'],
  
  // Rotas para Atendentes, Recepção e Admin
  '/dashboard': ['Admin', 'admin', 'Atendente', 'atendente'],
  
  // Rotas para todos os usuários autenticados
  '/painel-recepcao': ['Admin', 'admin', 'Atendente', 'atendente', 'Recepção', 'Recepcao', 'recepção', 'recepcao'],
  '/painel-chamada': ['Admin', 'admin', 'Recepção', 'Recepcao', 'recepção', 'recepcao'],
  '/emitir-senha': ['Admin', 'admin', 'Recepção', 'Recepcao', 'recepção', 'recepcao'],
  
  // Rotas acessíveis por todos os roles
  '/relatorios': ['Admin', 'admin', 'Atendente', 'atendente', 'Recepção', 'Recepcao', 'recepção', 'recepcao'],
  
  // Rotas exclusivas para Admin
  '/usuarios': ['Admin', 'admin'],
  '/configuracoes': ['Admin', 'admin'],
  '/configuracoes/servicos-senhas': ['Admin', 'admin'],
  '/painel-configuracao': ['Admin', 'admin'],
  '/configuracao-tickets': ['Admin', 'admin'],
  '/branding': ['Admin', 'admin'],
};

/**
 * Verifica se um usuário tem permissão para acessar uma rota específica
 * @param {string} route - A rota a ser verificada
 * @param {string} cargo - O cargo do usuário
 * @returns {boolean} - Retorna true se o usuário tem acesso, false caso contrário
 */
export const hasRoutePermission = (route, cargo) => {
  if (!route || !cargo) {
    console.log('Verificação de permissão falhou: rota ou cargo ausente', { route, cargo });
    return false;
  }
  
  const routePermissions = ROUTES_PERMISSIONS[route];
  
  if (!routePermissions) {
    console.log('Rota não encontrada nas permissões:', route);
    return false;
  }
  
  // Normaliza o cargo para comparação case-insensitive
  const normalizedCargo = cargo.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const hasAccess = routePermissions.some(permittedRole => {
    const normalizedRole = permittedRole.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return normalizedRole === normalizedCargo;
  });
  
  // console.log(`Verificação de permissão para rota: ${route}, cargo: ${cargo}, resultado: ${hasAccess}`);
  
  return hasAccess;
};

/**
 * Filtra um array de itens de menu com base nas permissões do usuário
 * @param {Array} menuItems - Array de itens de menu
 * @param {string} cargo - O cargo do usuário
 * @returns {Array} - Array filtrado apenas com os itens que o usuário tem acesso
 */
export const filterMenuItemsByPermission = (menuItems, cargo) => {
  if (!menuItems || !cargo) {
    console.log('Filtragem de menu falhou: itens de menu ou cargo ausente', { menuItems: !!menuItems, cargo });
    return [];
  }
  
  const filteredItems = menuItems.filter(item => hasRoutePermission(item.path, cargo));
  // console.log(`Itens de menu filtrados para cargo ${cargo}:`, filteredItems.map(item => item.path));
  
  return filteredItems;
}; 